import "../styles/ol.css";
import "../styles/ol-ext.css";


import Attribution from 'ol/control/Attribution';

import FullScreen from 'ol/control/FullScreen';

import Graticule from 'ol-ext/control/Graticule';

import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import Map from 'ol/Map';
import RasterSource from 'ol/source/Raster';
import TextButton from 'ol-ext/control/TextButton';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import Toggle from 'ol-ext/control/Toggle';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import WMSCapabilities from 'ol/format/WMSCapabilities';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import XYZ from 'ol/source/XYZ';
import proj4 from 'proj4';
import {Circle, Fill, Stroke, Style, Text} from 'ol/style';
import {Control, ScaleLine, defaults as defaultControls} from 'ol/control';
import {fromLonLat} from 'ol/proj';
import {getPointResolution, get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth} from 'ol/extent';
import {register} from 'ol/proj/proj4';

import MousePosition from 'ol/control/MousePosition';
import {createStringXY} from 'ol/coordinate';
//import HistogramControl from "./FGHistogramControl";
//import ClickInfoControl from "./FGClickInfoControl";


proj4.defs(
  'EPSG:26911',
  '+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
);
register(proj4);
const proj26911 = getProjection('EPSG:26911');
proj26911.setExtent([196765.3486, 2749459.8086, 803234.6514, 8799482.7282]);
const projectExtent = proj26911.getExtent();

const grat = new Graticule({
  step: 40,
  stepCoord: 2,
  projection: 'EPSG:26911',
});


//var scaleLine = new ScaleLine({});
const scaleLine = new ScaleLine({bar: true, text: true, minWidth: 125});
const view = new View({
  // center: fromLonLat([54.6, -111.9]),
  center: [486386,6177992],
  projection: proj26911,
   zoom: 12,
});

//grid

function toggleGraticuleLines(on) {
  let style;
  if (on) {
    style = new Style({
      text: new Text({
        font: '12px Calibri,sans-serif',
        rotation: 0,
        textAlign: 'left',
        overflow: true,
        fill: new Fill({
          color: '#000',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3,
        }),
      }),
      stroke: new Stroke({
        color: '#000',
        width: 1,
      }),
      fill: new Fill({
        color: '#fff',
      }),
    });
  } else {
    style = new Style({
      text: new Text({
        font: '12px Calibri,sans-serif',
        rotation: 0,
        textAlign: 'left',
        overflow: true,
        fill: new Fill({
          color: '#000',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3,
        }),
      }),
      fill: new Fill({
        color: '#000',
      }),
    });
  }
  grat.setStyle(style);
  map.render();
}
const mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection: 'EPSG:26911',
  // comment the following two lines to have the mouse position
  // be placed within the map.
  //className: 'custom-mouse-position',
  //target: document.getElementById('mouse-position'),
});
const map1 = new Map({
  target: 'fcMap',
  units: 'm',
  layers: [
    new TileLayer({
      title: "Jul 15 2018", 
      visible: true,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180715_432',
            },
        }),     
    }),
    new TileLayer({
      title: "Jul 18 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180718_432',
                                 },
        }),     
    }),
    new TileLayer({
      title: "Jul 28 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180728_432',
                                 },
        }),     
    }),
    new TileLayer({
      title: "Aug 05 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180805_432',
                                 },
        }),     
    }),
    new TileLayer({
      title: "EM31 Sept 20 2018 ", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:em31_breakcolor',
                                 },
        }),     
    }),
  ],
  view: view,
});
const map2 = new Map({
  target: 'ncMap',
  units: 'm',
  controls: defaultControls().extend([scaleLine]),
  layers: [
    new TileLayer({
      title: "Jul 15 2018", 
      visible: true,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180715_321',
            },
        }),     
    }),
    new TileLayer({
      title: "Jul 18 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180718_321',
                                 },
        }),     
    }),
    new TileLayer({
      title: "Jul 28 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180728_321',
                                 },
        }),     
    }),
    new TileLayer({
      title: "Aug 05 2018", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:parklandgeo-planet_20180805_321',
                                 },
        }),     
    }),
    new TileLayer({
      title: "EM31 Sept 20 2018 ", 
      visible: true,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Break:em31_breakcolor',
                                 },
        }),     
    }),
  ],
  view: view,
});


// map.addControl(grat);

const layerSwitcher1 = new LayerSwitcher();
const layerSwitcher2 = new LayerSwitcher();
map1.addControl(layerSwitcher1);
map2.addControl(layerSwitcher2);




